/** @module SiteAdmin/CrewRoleUsersTable */
define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"csi/xml",
	"csi/xml/Query",
	"SiteAdmin"
], function(declare, Widget, xml, Query, SiteAdmin) {

	return declare(Widget, {
		disableCustomViewToolbar: true,

		/** @property {boolean} displayGlobalAssignments - indicates whether the toggle is set, true for set, false for unset */
		displayGlobalAssignments: false,

		/** @property {boolean} bFreezeToggle - flag to freeze or unfreeze toggle based on whether team roles have been configured at this level */
		bFreezeToggle: false,

		/** @property {boolean} bAllowGlobalUsers - indicates if crew accepts global users */
		bAllowGlobalUsers: false,

		// @property {boolean} isForAssignedAgentCrew - indicates whether the table is for AssignedAgentCrewRoleUsers
		isForAssignedAgentCrew: false,

		/**
		 * Return true if crew users are allowed to be added to the role
		 * @return {boolean}
		 */
		accessActionAllowCrewUsers: function(ctx, action) {
			return !this.bAllowGlobalUsers;
		},

		/**
		 * Return true if global users are allowed to be added to the role
		 * @return {boolean}
		 */
		accessActionAllowGlobalUsers: function(ctx, action) {
			return this.bAllowGlobalUsers;
		},

		/**
		 * @override
		 * Determine if crew type allows global users
		 */
		onViewRootResponse: function(res) {
			var crewNode = this.getViewNode();
			var configNode = this.cacheView.getPathNode(crewNode, "Child:__Parent__/Child:CrewType/Child:Production");
			if (configNode) {
				this.bAllowGlobalUsers = configNode.AllowGlobalUsers;
			}
		},

		/**
		 * @override
		 * Clean up old reports
		 */
		_resetStores: function() {
			var cache = this.cacheView;

			cache.query({"$Type": "CrewAssignmentReport"}).forEach(function(node) {
				cache.remove(node.$URL);
			});

			this.inherited(arguments);
		},

		/**
		 * @override
		 * Don't add dependency paths as server uses Dep.CrewRoleAssignment
		 */
		onCreateMainQueryLevel: function(ql) {
			const crewNode = this.getViewNode();
			let isSharedCrew = true;
			let isMaterial = true;
			let level = "SharedCrewLevel:";

			// NOTE: crewNode will in practice always exist, but could be null when using the requestGenerator
			if (crewNode) {
				const crewHolder = this.cacheView.getNode(crewNode.__Parent__);

				isSharedCrew = crewNode.$Type == "SharedCrew";
				isMaterial = crewHolder.$Type == "Material";
				level = crewHolder.ForLevel;

				let productionPath = xml.path("Child:CrewType/Child:Production");
				if (isMaterial) {
					productionPath = xml.path("Child:MaterialSecurityGroups/Index:0", productionPath);
				}

				const productionNode = this.cacheView.getPathNode(crewHolder, productionPath);
				if (!productionNode.TeamRoles?.length) {
					this.displayGlobalAssignments = true;
					this.bFreezeToggle = true;
				}
			}

			// if on SharedCrew view, we need to create separate query
			if (isSharedCrew && !this.displayGlobalAssignments) {
				ql.serverQuery = new Query().Attr(xml.ATTR_NAME, xml.OP_EQUALS, xml.enumGetText(level), "Parent:TeamRoles");
			}

			// if on Material view, we need to create separate query
			if (isMaterial && !this.displayGlobalAssignments) {
				ql.serverQuery = new Query().Attr(xml.ATTR_NAME, xml.OP_EQUALS, "MaterialSecurityGroup", "Parent:TeamRoles");
			}
			// if on Assigned Agent Crew view, we need to use the AssignedAgentCrewRoleUsers view
			const crewUrl = SiteAdmin.getOnlineSupplierCrew(this.getCache(), crewNode, this.isForAssignedAgentCrew);
			ql.requestParameters = {
				"Dep.CrewRoleAssignment": crewUrl,
				"Dep.CrewIncludeGlobal": false,
				"Qry.Limit.Path": (!this.displayGlobalAssignments && !isSharedCrew && !isMaterial) ?
					[xml.getUrlPath(crewUrl, xml.path(xml.ATTR_PARENT, "CrewType", "Production", "TeamRoles")),
					xml.getUrlPath(crewUrl, xml.path("Assignments", "Role"))] : null
			};
		}
	});
});